/** Price lists, sales reps and delivery challans (wholesale and distribution). */
import { z } from "zod";
import { bdMobileSchema } from "./auth";
import { idSchema, poishaSchema } from "./inventory";

const name = z.string().trim().max(60);

export const priceTierSchema = z
  .object({ nameEn: name.default(""), nameBn: name.default(""), active: z.boolean().default(true) })
  .refine((v) => v.nameEn !== "" || v.nameBn !== "", { message: "Enter a name", path: ["nameEn"] });
export type PriceTierInput = z.output<typeof priceTierSchema>;

/** Sets prices on a list; null removes an item from it so the normal price applies. */
export const tierPricesSetSchema = z.object({
  prices: z
    .array(
      z.object({
        variantId: idSchema,
        unitCode: z.string().min(1).max(16),
        price: poishaSchema.nullable(),
      }),
    )
    .min(1)
    .max(500),
});
export type TierPricesSet = z.output<typeof tierPricesSetSchema>;

export const salesRepSchema = z.object({
  name: z.string().trim().min(2).max(80),
  phone: bdMobileSchema.nullable().optional(),
  commissionBps: z.number().int().min(0).max(5_000).default(0),
  active: z.boolean().default(true),
});
export type SalesRepInput = z.output<typeof salesRepSchema>;

export const deliveryChallanSchema = z.object({
  deliverTo: z.string().trim().min(3).max(300),
  vehicleNo: z.string().trim().max(40).optional(),
  driverName: z.string().trim().max(80).optional(),
  driverPhone: bdMobileSchema.optional(),
  note: z.string().trim().max(300).optional(),
});
export type DeliveryChallanInput = z.output<typeof deliveryChallanSchema>;
